<div class="flex text-radish items-center">
  <p class="small text-red-500">
      <strong>
        {{ text }}
      </strong>
  </p>
</div>
